import { Divider, Typography, Menu, MenuItem } from '@material-ui/core';
import { AttachFile, Cancel, Refresh, ArrowDropDown } from '@material-ui/icons';
import { errorMessages } from 'common/errorMessages.strings';
import { BaseDocumentResponse, CadastroNCByFile, FileResponse, FuncaoParticipante, GrupoAcesso, Modulos, ParticipanteResponse, Perfil, RegistroStatus } from 'common/genericTypes';
import { AutoComplete, Button, Dropdown, MdSpace, SmSpace, TextButton } from 'm2m.components';
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import AWS from 'aws-sdk';
import { Attachment, Download } from 'mdi-material-ui';
import { DataGridPro, GridCellParams, GridSortDirection, GridSortModel, GridValueGetterParams, GridComparatorFn } from '@mui/x-data-grid-pro';
import { componentsPropsValues, localizedTextsMap, rowsPerPageOptionsValues } from 'utils/dataGrid/dataGridUtils';
import CustomToolBarUtils from 'utils/dataGrid/customToolBar';
import DownloadIcon from '@material-ui/icons/GetApp';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Option, tipoArquivoS3Options } from 'common/genericOptions';
import _ from 'lodash';
import { addAlert } from 'store/modules/snackBar';
import moment, { Moment } from 'moment-timezone';
import InvestidorEmLote from 'components/investidoresEmLote/investidoresEmLote';
import FundosInvestidoresEmLote from 'components/fundosInvestidoresEmLote/fundosInvestidoresEmLote';

export interface Attachment {
  id: string;
  file?: File;
  remoteFileInfo?: BaseDocumentResponse;
}

interface UploadProps {
  fileId?: string;
  disabled?: boolean;
  disableRemove?: boolean;
  inputAttachments?: Attachment[];
  onChange?(attachments: Attachment[]): void;
  onDelete?(id: string): void;
  onError?(error: any): void;
  multipleFiles?: boolean;
  aditamento?: boolean;
  overrideAcceptableFileTypes?: Array<AcceptableFileTypes>;
}

export enum AcceptableFileTypes {
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png',
  AppWord = 'application/msword',
  AppWordGeneric = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  AppExcel = 'application/vnd.ms-excel',
  AppExcelGeneric = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  AppPdf = 'application/pdf',
  Txt = 'text/plain',
  Zip = 'application/zip',
  XZipCompressed = 'application/x-zip-compressed',
  Html = 'text/html',
  Email = 'message/rfc822',
}

export const defaultAcceptableFileTypes = [
  AcceptableFileTypes.ImageJpeg,
  AcceptableFileTypes.ImagePng,
  AcceptableFileTypes.AppWord,
  AcceptableFileTypes.AppWordGeneric,
  AcceptableFileTypes.AppExcel,
  AcceptableFileTypes.AppExcelGeneric,
  AcceptableFileTypes.AppPdf,
  AcceptableFileTypes.Txt,
  AcceptableFileTypes.Zip,
  AcceptableFileTypes.XZipCompressed,
  AcceptableFileTypes.Html,
  AcceptableFileTypes.Email,
];

const UploadDocsS3: React.FC<UploadProps> = (props) => {
  const { inputAttachments, overrideAcceptableFileTypes, disableRemove } = props;
  const [highlight, setHightlight] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [attachments, setAttachments] = useState<Array<Attachment>>([]);
  const [file, setFile] = useState<File | undefined>()
  const [formattedData, setFormattedData] = useState<Array<FileResponse>>([])
  const inputRef = useRef<HTMLInputElement>(null);
  const s3 = new AWS.S3();
  const [pageSize, setPageSize] = React.useState(20);

  const isUsuarioMaster = useSelector((state: RootState) => state.auth.usuario.participante.perfil) === Perfil.Master;
  const isUsuarioOperacoes = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroOperacoes = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const isParticipaeComum = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Comum;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil) === Perfil.Leitura;
  const isUsuarioEscrita = useSelector((state: RootState) => state.auth.usuario.participante.perfil) === Perfil.Escrita;
  const isUsuarioModuloUploadArquivos = useSelector((state: RootState) => Boolean(state.auth.usuario.modulos.find((modulo) => modulo.nomeEnum === Modulos.UPLOAD_ARQUIVOS)));
  const isParticipanteCustodiante = useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isParticipanteEscriturador = useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const usuarioLogado = useSelector((state: RootState) => state.auth.usuario.participante);

  const usuarioLogadoEmail = useSelector((state: RootState) => state.auth.usuario.email);
  const usuarioLogadoParticipanteId = useSelector((state: RootState) => state.auth.usuario.participante.id);

  const getParticipantesList = useSelector((state: RootState) => state.participanteApi.getParticipantes);
  const [custodianteOptions, setCustodianteOptions] = useState<Array<Option>>([]);
  const [selectedCustodiante, setSelectedCustodiante] = useState<Option>({ value: '', description: '' });

  const notaComercialByFileApi = useSelector((state: RootState) => state.notaComercialByFileApi);

  const searchParams = new URLSearchParams(window.location.search);
  const tipoParam = searchParams.get('tipo');

  const [arquivoS3Options, setArquivoS3Options] = useState<Array<Option>>(tipoArquivoS3Options);
  const [selectedArquivoS3, setSelectedArquivoS3] = useState<string>(tipoParam === 'CadastroEmLote' ? 'CadastroLote' : '');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: 'dataResponse',
      sort: 'desc' as GridSortDirection,
    },
  ]);

  const dispatch = useDispatch();

  let participante = [] as ParticipanteResponse[];

  const acceptedFileTypes = !!overrideAcceptableFileTypes?.length
    ? overrideAcceptableFileTypes
    : defaultAcceptableFileTypes;

  const getParticipantes = useCallback(async () => {
    setLoading(true);
    if (isUsuarioOperacoes || isUsuarioCadastroOperacoes) {
      const result = await getParticipantesList(dispatch, { funcao: FuncaoParticipante.Custodiante, suspenso: false, status: RegistroStatus.Aprovado }, true);
      participante = result;
      const options = result.map((participante) => ({
        value: participante.id,
        description: participante.razaoSocial,
      }));
      setCustodianteOptions(options);
    }
    fetchFiles();
    setLoading(false);
  }, [dispatch, getParticipantesList, participante]);

  const isValidFileType = (files: File[]): boolean => {
    return acceptedFileTypes.some((type) => files.some((file) => file?.type === type));
  };

  const handleFileTypeError = () => {
    props.onError?.(errorMessages.validation.upload.invalidExtension);
    setHightlight(false);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadInvestidor = () => {
    window.open("https://laqus-static-prod.s3.sa-east-1.amazonaws.com/solicitacoes/Modelo_Cadastro_Investidores_Em_Lote.xlsx", '_blank');
    handleMenuClose();
  };

  const handleDownloadFundoInvestidor = () => {
    window.open("https://laqus-static-prod.s3.sa-east-1.amazonaws.com/solicitacoes/Modelo_Cadastro_Fundos_Em_Lote.xlsx", '_blank');
    handleMenuClose();
  };

  const openFileDialog = () => {
    if (props.disabled) return;
    inputRef?.current?.click();
  };

  const onDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setFile(undefined);
    setAttachments([]);
    if (props.disabled) return;
    let newFiles: File[] = [];
    if (props.multipleFiles) {
      newFiles = Array.from(event.dataTransfer.files);
    } else if (event.dataTransfer.files) {
      newFiles[0] = event.dataTransfer.files[0];
    }

    if (!newFiles.length) return;

    if (!isValidFileType(newFiles)) {
      handleFileTypeError();
      return;
    }

    const newAttachments = newFiles.map((newFile) => {
      return {
        id: props.fileId ?? uuid(),
        file: newFile,
      };
    });
    setAttachments(newAttachments);
    setFile(event.dataTransfer.files[0]);
    setHightlight(false);
  };

  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (props.disabled) return;
    setHightlight(true);
  };

  const onDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (props.disabled) return;
    setHightlight(false);
  };

  const onInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setFile(undefined);
    setAttachments([]);
    let newFiles: File[] = [];
    if (event.target.files) {
      newFiles[0] = event.target.files?.[0];
    }

    if (!newFiles.length) return;

    if (!isValidFileType(newFiles)) {
      handleFileTypeError();
      return;
    }

    const newAttachments = newFiles.map((newFile) => {
      return {
        id: props.fileId ?? uuid(),
        file: newFile,
      };
    });

    let updatedAttachments: Attachment[];
    if (props.fileId && attachments.some(({ id }) => id === props.fileId)) {
      updatedAttachments = attachments.filter((file) => file.id !== props.fileId).concat(newAttachments);
    } else {
      updatedAttachments = attachments.concat(newAttachments);
    }

    props.onChange?.(newAttachments);
    setHightlight(false);
    setAttachments(newAttachments);
    setFile(event.target.files?.[0]);
  };

  const onDeleteClick = (id: string) => {
    setAttachments([]);
    const newFiles = attachments.filter((file) => file.id !== id);
    props.onDelete?.(id);
    setFile(undefined);
    setAttachments(newFiles);
  };

  const getBase64 = async (file: File) => {
    let base64File;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    await new Promise((resolve) => {
      reader.onload = () => {
        base64File = reader.result;
        resolve(base64File);
      };
    });
    return reader;
  }

  const uploadFile = async (file: File | undefined) => {
    const file2Base64: string = (await getBase64(file as File)).result as string;
    try {
      if (selectedArquivoS3 == "CadastroLote") {
        await notaComercialByFileApi.postNotaComercialCadastroLoteByFile(dispatch, file, true);
        dispatch(addAlert({ severity: 'success', message: 'Arquivo enviado com sucesso!' }));
        return;
      }

      if (selectedArquivoS3 == "CadastroFundosLote") {
        await notaComercialByFileApi.postFundosInvestidoresLoteByFile(dispatch, file, true);
        dispatch(addAlert({ severity: 'success', message: 'Arquivo enviado com sucesso!' }));
        return;
      }

      const notaComercial: CadastroNCByFile = {
        diretorio: `${isParticipanteCustodiante ? usuarioLogado.id : selectedCustodiante.value}/request/${selectedArquivoS3}`,
        nomeArquivo: file?.name ?? '',
        arquivo: file2Base64.split(',')[1],
      }

      await notaComercialByFileApi.postNotaComercialByFile(dispatch, notaComercial, true);
      dispatch(addAlert({ severity: 'success', message: 'Arquivo enviado com sucesso!' }));
      return;
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: 'Falha ao enviar arquivo.' }));
      return {};
    }
  };

  const enableUploadButton = () => {
    if (isParticipanteCustodiante && file && selectedArquivoS3 !== '') {
      return false;
    } else if (!isParticipanteCustodiante && file && selectedArquivoS3 !== '' &&
      selectedCustodiante && selectedCustodiante.value !== '') {
      return false;
    } else {
      return true;
    }
  }

  const fetchFiles = useCallback(async () => {
    try {

      const params = () => isParticipanteCustodiante ? {
        diretorio: usuarioLogado.id.toString() + '/request',
        bucket: process.env['REACT_APP_AWS_BUCKET_SFTP'] || '',
      } : {
        bucket: process.env['REACT_APP_AWS_BUCKET_SFTP'] || '',
      };

      const getNotasComerciais = await notaComercialByFileApi.getAllNotasComerciaisByFile(dispatch, params(), true);
      let counter = 0;
      let informacoes: FileResponse[] = [];

      getNotasComerciais.forEach((arr, i) => {
        const keys = arr.diretorio.split("/");
        if (keys.length > 2 && keys[1] === "request") {
          const custodianteId = keys[0];
          const razaoCustodiante = isParticipanteCustodiante
            ? usuarioLogado.razaoSocial
            : (participante.find(part => part.id === custodianteId) || {}).razaoSocial;

          if (isParticipanteCustodiante && custodianteId === usuarioLogado.id.toString()) {
            informacoes.push({
              id: counter++,
              razaoCustodiante: razaoCustodiante,
              nomeArquivo: arr.nomeArquivo,
              tipoArquivo: keys[2],
              dataResponse: arr.dataModificacao,
              fileResponse: `${arr.diretorio}/${arr.nomeArquivo}`,
            });
          } else if (!isParticipanteCustodiante) {
            informacoes.push({
              id: counter++,
              razaoCustodiante: razaoCustodiante,
              nomeArquivo: arr.nomeArquivo,
              tipoArquivo: keys[2],
              dataResponse: arr.dataModificacao,
              fileResponse: `${arr.diretorio}/${arr.nomeArquivo}`,
            });
          }
        }
      });

      setFormattedData(informacoes);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching files: ', error);
    }
  }, [formattedData]);

  const handleDownload = useCallback(async (fileResponse: string, fileName: string) => {
    try {
      if (fileResponse && fileName) {
        const params = {
          diretorio: fileResponse.split('/').slice(0, -1).join('/') || '',
          bucket: process.env['REACT_APP_AWS_BUCKET_SFTP'] || '',
          nomeArquivo: fileResponse.split('/').slice(-1)[0] || '',
        };

        const blob = await notaComercialByFileApi.getFileDownloadArquivo(dispatch, params, true);

        if (blob) {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          
          setTimeout(() => window.URL.revokeObjectURL(link.href), 100);
        }
      }
    } catch (error) {
      dispatch(addAlert({ 
        severity: 'error', 
        message: 'Erro ao baixar arquivo. Tente novamente.' 
      }));
    }
  }, [dispatch]);

  const dateComparator: GridComparatorFn<Date> = (v1: Date, v2: Date) => moment(v1).diff(v2);

  const startCustomerX = () => {
    setTimeout(() => {
      // @ts-ignore
      cx.survey('authorize', process.env['REACT_APP_CUSTOMERX_KEY']);
      // @ts-ignore
      cx.survey('identify', { external_id_client: usuarioLogadoParticipanteId, email: usuarioLogadoEmail });
      // @ts-ignore
      cx.survey('start', 'nps');
    }, 5000)
  }

  useEffect(() => {
    startCustomerX();
  }, []);

  useEffect(() => {
    getParticipantes();
  }, []);

  const getGridColumns = useCallback(
    () => [
      {
        field: 'razaoCustodiante',
        headerName: 'Razão Custodiante',
        type: 'string',
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 200,
        minWidth: 100,
        maxWidth: 200,
        onColumnWidthChange: true,
        valueGetter: (params: GridValueGetterParams) => (params.row as FileResponse).razaoCustodiante,
      },
      {
        field: 'nomeArquivo',
        headerName: 'Nome Arquivo',
        filterable: true,
        sortable: true,
        valueGetter: (params: GridValueGetterParams) => (params.row as FileResponse).nomeArquivo,
        width: 200,
        minWidth: 100,
        maxWidth: 300,
      },
      {
        field: 'dataResponse',
        headerName: 'Data de Resposta',
        filterable: true,
        sortable: true,
        type: 'date',
        sortComparator: dateComparator,
        valueGetter: (params: GridValueGetterParams) => (params.row as FileResponse).dataResponse,
        renderCell: (params: GridCellParams) => {
          return (params.row as FileResponse).dataResponse
            ? moment((params.row as FileResponse).dataResponse).format('DD/MM/YYYY, HH:mm:ss')
            : '';
        },
        width: 220,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'tipoArquivo',
        headerName: 'Tipo do Arquivo',
        filterable: true,
        sortable: true,
        disableExport: false,
        valueGetter: (params: GridValueGetterParams) => (params.row as FileResponse).tipoArquivo,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
      },
      {
        field: 'file_response_download',
        headerName: 'Download do Arquivo',
        filterable: true,
        sortable: true,
        valueGetter: (params: GridValueGetterParams) => (params.row as FileResponse).fileResponse,
        renderCell: (params: GridCellParams) => {
          const response = params.row as FileResponse;
          return (
            <>
              <TextButton onClick={() => { handleDownload(response.fileResponse || "", response.nomeArquivo || "") }}>
                {'Download'}
                <DownloadIcon style={{ marginLeft: 10 }} fontSize={'small'} />
              </TextButton>
            </>
          );
        },
        width: 200,
        minWidth: 150,
        maxWidth: 200,
      },
    ],
    []
  );

  const hideCondition =
    (isUsuarioOperacoes && isUsuarioMaster) ||
    (isUsuarioOperacoes && isUsuarioLeitura) ||
    (isParticipanteCustodiante && isUsuarioLeitura) ||
    (isUsuarioCadastroOperacoes && isUsuarioLeitura);

  const showCondition =
    (isUsuarioOperacoes && isUsuarioEscrita) ||
    (isParticipanteCustodiante && isUsuarioEscrita) ||
    (isParticipanteCustodiante && isUsuarioMaster) ||
    (isUsuarioCadastroOperacoes && isUsuarioEscrita) ||
    (isUsuarioCadastroOperacoes && isUsuarioMaster);

  return (
    <Fragment>
      {showCondition && !hideCondition && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <Dropdown
                label={'Tipo Arquivo'}
                value={selectedArquivoS3}
                onChange={(value) => setSelectedArquivoS3(value)}
                options={arquivoS3Options}
                style={{ width: '400px' }}
              />

              {(!isParticipanteCustodiante && selectedArquivoS3 !== 'CadastroLote' && selectedArquivoS3 !== 'CadastroFundosLote') && (
                <AutoComplete
                  label={'Participante'}
                  value={selectedCustodiante}
                  onChange={(value) => setSelectedCustodiante(value)}
                  options={_.orderBy(custodianteOptions, (x) => moment(x.description), 'desc')}
                  filterOptions={(options: Array<Option>, state) => options.filter((_) => _.description.toLocaleLowerCase().includes(state.inputValue.toLocaleLowerCase()))}
                  getOptionLabel={(option: Option) => option.description}
                  style={{ width: '400px' }}
                />
              )}
            </div>

            {(selectedArquivoS3 === 'CadastroLote' || selectedArquivoS3 === 'CadastroFundosLote') && (
              <>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleMenuClick}
                  endIcon={<ArrowDropDown />}>
                  <Download fontSize="small" style={{ marginRight: '10px' }} />
                  {'Baixar planilha Modelo'}
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}>
                  <MenuItem onClick={handleDownloadInvestidor}>
                    <Download fontSize="small" color="primary" style={{ marginRight: '10px' }} />
                    <span style={{ color: 'inherit' }}>Baixar planilha Modelo Investidor</span>
                  </MenuItem>
                  <MenuItem onClick={handleDownloadFundoInvestidor}>
                    <Download fontSize="small" color="primary" style={{ marginRight: '10px' }} />
                    <span style={{ color: 'inherit' }}>Baixar planilha Modelo Fundo Investidor</span>
                  </MenuItem>
                </Menu>
              </>
            )}

          </div>

          <SmSpace></SmSpace>
          {selectedArquivoS3 === 'CadastroLote' ?
            (
              <InvestidorEmLote />
            ) : selectedArquivoS3 === 'CadastroFundosLote' ?
            (
              <FundosInvestidoresEmLote />
            ) :
            (
              <>
                <div
                  onClick={openFileDialog}
                  onDragOver={onDragOver}
                  onDragLeave={onDragLeave}
                  onDrop={onDrop}
                  style={{
                    width: '100%',
                    border: '1px dashed #D7D8D9',
                    borderRadius: '8px',
                    cursor: props.disabled ? 'default' : 'pointer',
                    textAlign: 'center',
                  }}
                >
                  <MdSpace />
                  <AttachFile fontSize="small" />
                  <Typography color="textSecondary" variant="body2">
                    {highlight
                      ? 'Solte para carregar os arquivos'
                      : `Arraste e solte ou SELECIONE OS DOCUMENTOS`}
                  </Typography>
                  <input
                    ref={inputRef}
                    type="file"
                    accept={acceptedFileTypes.join(',')}
                    multiple={false}
                    style={{ display: 'none' }}
                    onChange={onInputChange}
                  />
                  <MdSpace />
                </div>
                <MdSpace />
                <div>
                  {attachments.concat(inputAttachments ?? []).map(({ id, file, remoteFileInfo }) => (
                    <div key={id}>
                      <Typography variant="subtitle1">{file?.name || remoteFileInfo?.fileName}</Typography>
                      <TextButton disabled={disableRemove} onClick={() => onDeleteClick(id)} startIcon={<Cancel />}>
                        {'Remover'}
                      </TextButton>
                    </div>
                  ))}
                </div>
                <Button
                  variant="contained"
                  size="small"
                  color='primary' disabled={enableUploadButton()} onClick={() => uploadFile(file)} >
                  {'Upload'}
                </Button>
              </>
            )
          }
        </>
      )}

      <Divider />

      <MdSpace />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">{'Histórico de Arquivos'}</Typography>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() => getParticipantes()} >
          <Refresh fontSize="small" style={{ marginRight: '10px' }} />
          {'Recarregar'}
        </Button>
      </div>

      <SmSpace />
      <DataGridPro
        autoHeight
        localeText={localizedTextsMap}
        componentsProps={componentsPropsValues}
        rows={formattedData}
        columns={getGridColumns()}
        components={{
          Toolbar: CustomToolBarUtils,
        }}
        disableSelectionOnClick
        rowsPerPageOptions={rowsPerPageOptionsValues}
        pagination
        onPageSizeChange={(newPage) => setPageSize(newPage)}
        pageSize={pageSize}
        loading={loading}
        sortModel={sortModel}
        onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
      />
    </Fragment>
  );
};

export default UploadDocsS3;
